/* tslint:disable */
 
import { Permission } from './permission';

/**
 * (tsType: Omit<EndUserViewsPermissionsDto, >, schemaOptions: { exclude: [] })
 */
export class EndUserViewsPermissionsDto {
  isAuthenticated?: boolean;
  isRestricted?: boolean;
  permissions?: Array<Permission>;
}
